export default "__VITE_ASSET__131d78c3__"